/**
 * Browser entry point. Everything below this line is DOM-bound; the protocol and state machinery lives
 * in the DOM-free core, shared verbatim with the terminal client (workspace-client.md §5).
 */
import { WorkspaceApp, parseJoinLink } from './app/workspaceApp.ts';

const mount = document.getElementById('app');
if (!mount) {
  throw new Error('missing #app mount element');
}

const language = globalThis.navigator?.language ?? 'en';
// An invitation link is still "the workspace" - it just arrives knowing which room to walk into. Same
// link format as the terminal's, deliberately: one session, two doors.
const app = new WorkspaceApp(mount, language, parseJoinLink(globalThis.location.hash) ?? undefined);
app.start();
